module.exports = __webpack_public_path__ + "static/media/The-Rogers-Foundation-color-logo (1).a5151346.png";